import request from '@/axios/index.js'

// 转让通知列表
export function transferNoticeList(data) {
    return request.axios({
        data:data,
        url: '/transfer/noticeList'
    })
}
// 转让通知阅读
export function transferUpdateMsgStCd(data) {
    return request.axios({
        data:data,
        url: '/transfer/updateMsgStCd'
    })
}
// 装让通知详情
export function transferNoticeDetail(data) {
    return request.axios({
        data:data,
        url: '/transfer/noticeDetail',
        noFailMsg: true
    })
}
// 消息集合
export function toDoListStatistics(data) {
  return request.axios({
      data:data,
      url: '/toDoListStatistics',
  })
}



// WEBPACK FOOTER //
// ./src/api/message.js